<template>
  <div class="flex flex-row gap-2 text-ellipsis">
    <div class="text-center my-auto">{{ params.displayName }}</div>
    <Button v-if="params.show" v-tooltip.top="'Paste'" icon="pi pi-clipboard text-xl" outlined class="h-8 w-8 p-0! border-0" @click="paste"></Button>
  </div>
</template>

<script setup lang="ts">
const props = defineProps(["params"]);

const paste = () => {
  navigator.clipboard.readText().then((text) => props.params.paste(props.params.column.colId, text, props.params.type, props.params.rounding));
};
</script>
